import React, { createContext, useReducer, useContext } from 'react';

// Initial state function
const getInitialState = () => {
  const storedState = JSON.parse(localStorage.getItem("state"));
  return storedState || {
    productCounters: {},
    totalCount: 0,
    productOrder: [],
  };
};

// Reducer function
const reducer = (state, { type, productId }) => {
  let updatedCount;
  let updatedProductOrder = [...state.productOrder];

  switch (type) {
    case 'add':
      const currentCount = state.productCounters[productId] || 0;
      updatedCount = currentCount + 1;

      const updatedCountersAdd = {
        ...state.productCounters,
        [productId]: updatedCount,
      };

      const existingProductIndex = updatedProductOrder.findIndex(
        (product) => product.productId === productId
      );

      if (existingProductIndex >= 0) {
        updatedProductOrder[existingProductIndex].currentCount = updatedCount;
      } else {
        updatedProductOrder.push({ productId, currentCount: updatedCount });
      }
      const newStateAdd = {
        ...state,
        productCounters: updatedCountersAdd,
        totalCount: state.totalCount + 1,
        productOrder: updatedProductOrder,
      };
      localStorage.setItem('state', JSON.stringify(newStateAdd));
      return newStateAdd;

    case 'sub':
      updatedCount = Math.max(0, state.productCounters[productId] - 1);

      const updatedCountersSub = {
        ...state.productCounters,
        [productId]: updatedCount,
      };

      const productIndexSub = updatedProductOrder.findIndex(
        (product) => product.productId === productId
      );

      if (productIndexSub >= 0) {
        if (updatedCount > 0) {
          updatedProductOrder[productIndexSub].currentCount = updatedCount;
        } else {
          updatedProductOrder.splice(productIndexSub, 1);
        }
      }

      const newStateSub = {
        ...state,
        productCounters: updatedCountersSub,
        totalCount: state.totalCount > 0 ? state.totalCount - 1 : 0,
        productOrder: updatedProductOrder,
      };
      localStorage.setItem('state', JSON.stringify(newStateSub));
      return newStateSub;

    case 'dele':
      const updatedCountersDel = { ...state.productCounters };
      const currentProductCount = updatedCountersDel[productId] || 0;
      delete updatedCountersDel[productId];

      updatedProductOrder = updatedProductOrder.filter(
        (product) => product.productId !== productId
      );

      const newStateDel = {
        ...state,
        productCounters: updatedCountersDel,
        totalCount: state.totalCount - currentProductCount,
        productOrder: updatedProductOrder,
      };

      localStorage.setItem('state', JSON.stringify(newStateDel));
      return newStateDel;

    case 'reset':
      // Resetting to the initial state
      const resetState = {
        productCounters: {},
        totalCount: 0,
        productOrder: [],
      };

      localStorage.setItem('state', JSON.stringify(resetState));
      return resetState;

    default:
      return state;
  }
};

const CounterContext = createContext();

export const CounterProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, getInitialState());

  return (
    <CounterContext.Provider value={{ state, dispatch }}>
      {children}
    </CounterContext.Provider>
  );
};

export const useCounter = () => useContext(CounterContext);

// Function to reset the state when submitting the order
export const resetOrder = (dispatch) => {
  dispatch({ type: 'reset' });
};
